var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3_308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6261 0H2.32059C1.03872 0 0 1.03872 0 2.32059V17.6771C0 18.9589 1.03872 19.9976 2.32059 19.9976H13.6261C14.9079 19.9976 15.9466 18.9589 15.9466 17.6771V2.32059C15.949 1.03872 14.9079 0 13.6261 0ZM11.5864 14.7568H4.38385C3.87394 14.7568 3.46081 14.3437 3.46081 13.8338C3.46081 13.3239 3.87394 12.9108 4.38385 12.9108H11.5864C12.0963 12.9108 12.5094 13.3239 12.5094 13.8338C12.5094 14.3437 12.094 14.7568 11.5864 14.7568ZM11.5864 10.4651H4.38385C3.87394 10.4651 3.46081 10.0519 3.46081 9.54202C3.46081 9.03211 3.87394 8.61898 4.38385 8.61898H11.5864C12.0963 8.61898 12.5094 9.03211 12.5094 9.54202C12.5094 10.0519 12.094 10.4651 11.5864 10.4651ZM11.5864 6.07413H4.38385C3.87394 6.07413 3.46081 5.661 3.46081 5.15109C3.46081 4.64117 3.87394 4.22805 4.38385 4.22805H11.5864C12.0963 4.22805 12.5094 4.64117 12.5094 5.15109C12.5094 5.661 12.094 6.07413 11.5864 6.07413Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.949,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/material_icon.9c3d46ed3da8d628156e49671c4708aa.svg";
export { ForwardRef as ReactComponent };